import RemoteSelectWithFilters from "common/components/RemoteSelect/RemoteSelectWithFilters";
import usePark from "common/hooks/usePark";
import { Animal } from "types/Animal";
import RemoteSelect, {
  RemoteSelectProps,
} from "common/components/RemoteSelect/RemoteSelect";
import getAnimalLabel from "utils/animalLabel";

export type AnimalSelectProps = {
  additionalFilters?: {
    name: string;
    key: string;
    component: React.ReactNode;
  }[];
} & {
  specyFilter?: {
    name: string;
    value: string;
  };
} & RemoteSelectProps;

const processOptions = (options: Animal[]) =>
  options.map(
    ({ id, houseName, zimsId, localId, tag, transponderId, band }) => {
      const label = getAnimalLabel(id, houseName, zimsId, localId, tag);
      return {
        value: id,
        label,
        // Champs supplémentaires rendus cherchables (transpondeur, bague, identifiants)
        searchText: [label, transponderId, band, localId, zimsId, tag]
          .filter(Boolean)
          .join(" ")
          .toLowerCase(),
      };
    }
  );

// Recherche sur le libellé + transpondeur + bague + identifiants (filtre client react-select)
const filterAnimalOption = (option: any, rawInput: string) => {
  const term = rawInput.trim().toLowerCase();
  if (!term) return true;
  const searchText =
    option?.data?.searchText ?? String(option?.label ?? "").toLowerCase();
  return searchText.includes(term);
};

function AnimalSelect({
  additionalFilters,
  specyFilter,
  ...props
}: AnimalSelectProps) {
  const { park } = usePark();

  return additionalFilters && additionalFilters.length > 0 ? (
    <RemoteSelectWithFilters
      url="animals"
      processOptions={processOptions}
      filters={
        specyFilter
          ? [{ name: "park", value: park?.id }, specyFilter]
          : [{ name: "park", value: park?.id }]
      }
      filtersComponents={additionalFilters}
      shouldRenderValue={false}
      clearable={false}
      filterOption={filterAnimalOption}
      {...props}
    />
  ) : (
    <RemoteSelect
      url="animals"
      processOptions={processOptions}
      filters={[{ name: "park", value: park?.id }]}
      filterOption={filterAnimalOption}
      {...props}
    />
  );
}

export default AnimalSelect;
